import axios from '@api';

import { transformSurveyType } from './utilities/helpers';

/**
 * read survey type
 * @param {Object} options
 * @param {String} options.documentId
 * @param {String} options.publicToken
 * @param {AbortSignal} [options.signal]
 * @return {Promise}
 */
export const readSurveyType = async ({ documentId, publicToken, signal }) => {
  // Bypass sending cookies when using publicToken
  const withCredentials = publicToken ? false : true;

  return axios({
    method: 'get',
    params: {
      publicToken,
    },
    signal,
    url: `/api/survey-types/${documentId}`,
    withCredentials,
  }).then(({ data }) => transformSurveyType(data));
};
